import React, { useEffect } from 'react';
import { isEmail } from 'react-jhipster';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { type FieldError, useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { handlePasswordResetInit, reset } from '../password-reset.reducer';
import { colors } from 'app/shared/theme/colors';
import { useTranslation } from 'app/shared/i18n';

export const PasswordResetInit = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const successMessage = useAppSelector(state => state.passwordReset.successMessage);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({ mode: 'onTouched' });

  useEffect(
    () => () => {
      dispatch(reset());
    },
    [],
  );
  useEffect(() => {
    if (successMessage) toast.success(successMessage);
  }, [successMessage]);

  const handleValidSubmit = ({ email }) => dispatch(handlePasswordResetInit(email));

  return (
    <div className="ms-auth">
      <div className="ms-auth__card ms-card">
        <div className="ms-auth__header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: 8,
                background: 'linear-gradient(135deg, #F59E0B, #F97316)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 16,
                fontWeight: 800,
                color: '#000',
              }}
            >
              M
            </div>
            <span style={{ fontSize: 16, fontWeight: 700, color: colors.text }}>
              Mails<span style={{ color: colors.accent }}>Ngon</span>
            </span>
          </div>
          <h2 style={{ fontSize: 18, fontWeight: 700, margin: '8px 0 0' }}>{t('passwordReset.initTitle')}</h2>
          <p style={{ fontSize: 13, color: colors.dim, marginTop: 4 }}>{t('passwordReset.initSubtitle')}</p>
        </div>
        <div className="ms-auth__body">
          <form onSubmit={handleSubmit(handleValidSubmit)}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: colors.muted, marginBottom: 6 }}>Email</label>
              <input
                className="ms-input"
                type="email"
                placeholder="email@example.com"
                data-cy="emailResetPassword"
                {...register('email', {
                  required: t('passwordReset.emailRequired'),
                  validate: v => isEmail(v) || t('passwordReset.emailInvalid'),
                })}
              />
              {errors.email && (
                <div style={{ fontSize: 12, color: colors.danger, marginTop: 4 }}>{(errors.email as FieldError).message}</div>
              )}
            </div>
            <button className="ms-btn ms-btn--primary" type="submit" data-cy="submit" style={{ width: '100%', padding: 12 }}>
              {t('passwordReset.sendResetLink')}
            </button>
          </form>
        </div>
        <div className="ms-auth__footer">
          <Link to="/login">{t('passwordReset.backToLogin')}</Link>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetInit;
